<template>
  <div style="height:100%;display:flex;" class="u-flex-column">
    <div style="height:160px;padding-left:160px">
      <el-form
        :size="'small'"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="统计时间">
          <el-date-picker
            style="width: 330px"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="time"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="selectType" label="查询类别统计">
            <el-select
                ref="Type"
                v-model="selectType"
                clearable
                placeholder="全部"
                style="width: 150px"
              >
              <el-option label="过车" value="1" />
              <el-option label="闸机车辆" value="2" />
              <el-option label="进场" value="3" />
              <el-option label="出场" value="4" />
            </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getdata">统计</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="u-text-center" style="font-size:0.22rem;color:#fff">
      {{ barData.name }}{{ barData.type }}统计
    </div>
    <div style="flex:1;min-height:0">
      <bar-echart :chart-data="barData" :key="eckey"></bar-echart>
    </div>
    <div style="height:220px;padding:12px 40px 20px">
      <statistic-detail-table :dates="tableDates" :rows="tableRows" />
    </div>
  </div>
</template>

<script>
// 导入组件
import BarEchart from "@/components/echarts/barEchart.vue";
import StatisticDetailTable from "@/components/echarts/StatisticDetailTable.vue";
import { setTime } from "@/commons/util.js";
import { createStatisticTableRows, getSelectedOptionLabel, VEHICLE_CATEGORY_OPTIONS } from "./statisticTable";
export default {
  data() {
    return {
      eckey:'',
      tableDates: [],
      tableRows: [],
      vehicleCategoryOptions: VEHICLE_CATEGORY_OPTIONS,
      barData: {
        name: "小轿车",
        type: "",
        /* data: [
          120,
          200,
          150,
          80,
          70,
          110,
          130,
          120,
          200,
          150,
          80,
          70,
          110,
          130,
          130
        ],
        xvalue: [
          "2021-01-02",
          "2021-01-03",
          "2021-01-04",
          "2021-01-05",
          "2021-01-06",
          "2021-01-07",
          "2021-01-08",
          "2021-01-09",
          "2021-01-10",
          "2021-01-11",
          "2021-01-12",
          "2021-01-13",
          "2021-01-14",
          "2021-01-15"
        ] */
      },
      formInline: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      time: setTime(15),
      selectType:""
    };
  },
  components: {
    BarEchart,
    StatisticDetailTable
  },
  methods: {
    getdata() {
      const data = {
        beginTime:this.time[0],
        endTime:this.time[1],
        pageIndex:1,
        pageRow:100,
        vehicleType:1,
        selectType:this.selectType
      };
      const tableRequests = this.vehicleCategoryOptions.map(item => {
        const tableData = Object.assign({}, data, { selectType: item.value });
        return this.$http.POST_statisticByVehicleType(tableData);
      });
      Promise.all([this.$http.POST_statisticByVehicleType(data)].concat(tableRequests)).then(results => {
        const res = results[0];
        const tableResults = results.slice(1);
        const dates = res.data.statisticKey || [];
        //console.log('统计结果',res);
        this.$set(this.barData,'data',res.data.statisticValue);
        this.$set(this.barData,'xvalue',dates);
        this.tableDates = dates;
        this.tableRows = createStatisticTableRows(dates, this.vehicleCategoryOptions, tableResults);
        this.eckey=new Date().getTime();
        this.barData.type = getSelectedOptionLabel(this.vehicleCategoryOptions, this.selectType, "");
      });
    }
  },
  mounted() {
    this.getdata()
  }
};
</script>

<style lang="scss">
input::-webkit-input-placeholder {
  font-size: 14px;
}
.el-form-item__label {
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/tjfx/xxjctj.vue